import React from "react";
import PlayPauseButtons from "./PlayPauseButtons";
import VolumeBar from "./VolumeBar";
import SpeedControl from "./SpeedControl";
import FullscreenControl from "./FullscreenControl";

const Controls = ({ isPlaying, onPlayPause, onSeekBackward, onSeekForward, volume, onVolumeChange, speed, onSpeedChange, isFullScreen, onToggleFullScreen, showVolume, setShowVolume, showSpeedOptions, setShowSpeedOptions, largeScreen }) => {
  return (
    <div className="mx-5 flex h-auto w-auto select-none items-center justify-between gap-2 py-2 text-white">
      <div className="flex gap-6">
        <PlayPauseButtons isPlaying={isPlaying} onPlayPause={onPlayPause} onSeekBackward={onSeekBackward} onSeekForward={onSeekForward} />
        <VolumeBar volume={volume} onVolumeChange={onVolumeChange} showVolume={showVolume} setShowVolume={setShowVolume} />
      </div>

      <div className="flex gap-8">
        <SpeedControl speed={speed} onSpeedChange={onSpeedChange} showSpeedOptions={showSpeedOptions} setShowSpeedOptions={setShowSpeedOptions} />
        {largeScreen && <FullscreenControl isFullScreen={isFullScreen} onToggleFullScreen={onToggleFullScreen} />}
      </div>
    </div>
  );
};

export default Controls;